import React, {useCallback, useEffect, useRef, useState} from 'react';
import {navigateHook} from "../../../../../hooks/use-navigate.js";
import {useQuery} from "@tanstack/react-query";
import {Template} from "../../../../../components/template/template.jsx";
import Button from "../../../../../components/button/button.jsx";
import {FaEraser, FaPlus, FaSearch} from "react-icons/fa";
import {Card} from "../../../../../components/card/card.jsx";
import InputForm from "../../../../../components/input/input-form.jsx";
import {AgGridReact} from "ag-grid-react";
import aggridUtils from "../../../../../utils/aggrid-utils.js";
import organizationService from "../../../../../services/web/organization-service.js";
import {useGlobalKey} from "../../../../../hooks/use-global-key.js";

const OrganizationList = () => {
    const navigate = navigateHook();

    const [state, setState] = useState("");
    const [data, setData] = useState([]);

    const {data: dataFetch} = useQuery({
        queryFn: () => organizationService.list(),
        queryKey: ["list"]
    });

    useEffect(() => {
        if (!dataFetch) return;
        setData(dataFetch)
    }, [dataFetch]);

    const [columnDefs,] = useState([
        { field: "id", headerName: "ID", width: 60},
        { field: "name", headerName: "Nome", sort: "asc", flex: 1},
    ]);

    const gridRef = useRef(undefined);

    const apply = useCallback(() => {
        setData(dataFetch?.filter(d => d.name?.toLowerCase().includes(state?.toLowerCase())))
    }, [state, dataFetch])

    const clear = useCallback(() => {
        setData(dataFetch)
        setState("");
    }, [dataFetch])

    useGlobalKey("Enter", apply);
    useGlobalKey("Escape", clear);

    const onCellClicked = ({data}) => {
        navigate(`/ecap-organization/form/${data.id}`)
    };

    return (
        <Template>
            <Template.Header>
                <Template.Title>Organizações</Template.Title>

                <Button target={"primary"} onClick={() => navigate("/ecap-organization/form")}>
                    <FaPlus/> Adicionar organização
                </Button>
            </Template.Header>

            <Template.Body className={"space-y-2"}>
                <Card>
                    <Card.Body>
                        <div className="flex justify-between gap-4">
                            <InputForm
                                classNameWrapper={"w-full"}
                                id={"name"}
                                label={"Nome"}
                                name={"name"}
                                value={state}
                                onChange={({target: {value}}) => setState(value)}
                            />

                            <div className={"flex gap-2"}>
                                <Button target={"default"} onClick={clear} title={"Limpar"}>
                                    <FaEraser />
                                </Button>
                                <Button onClick={apply} title={"Buscar"}>
                                    <FaSearch />
                                </Button>
                            </div>
                        </div>
                    </Card.Body>
                </Card>

                <Card>
                    <Card.Body>
                        <div className={"aggrid-row-pointer"} style={{height: "calc(100vh - 153px)"}}>
                            <AgGridReact
                                ref={gridRef}
                                rowData={data ?? []}
                                columnDefs={columnDefs}
                                pagination
                                paginationPageSize={100}
                                paginationPageSizeSelector={[20, 50, 100, 500]}
                                animateRows={false}
                                suppressCellFocus={true}
                                onCellClicked={onCellClicked}
                                gridOptions={{localeText: aggridUtils.localization()}}
                                theme={aggridUtils.generalTheme()}
                            />
                        </div>
                    </Card.Body>
                </Card>
            </Template.Body>
        </Template>
    );
};

export default OrganizationList;